<template>
  <el-table-column
    prop="supplier.name"
    label="Kezdeti készlet"
    min-width="200"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.from_count_per_pack === 1">
              {{ scope.row.from_count}} db
      </span>
      <span v-else>
              {{ scope.row.from_count}} {{ scope.row.from_pack_type_name}}
      </span>
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'supplier.name',
  };
</script>
